import type { MessageDescriptor } from 'react-intl';
import type { MetaFunction } from '@remix-run/react';

import { intl } from '~/i18n';
import type { RootLoaderData } from '~/root.server';

export const createMeta =
  (
    title: string | MessageDescriptor,
  ): MetaFunction<null, { root: RootLoaderData }> =>
  ({ matches }) => {
    const { locale } = matches.find(({ id }) => id === 'root')?.data ?? {};

    return [
      {
        title:
          typeof title !== 'string' ? intl(locale).formatMessage(title) : title,
      },
    ];
  };
